import * as yup from "yup";
import { CurrencyType } from "../../../../common/enums";

export const addPaymentTypeFormSchema = yup
  .object({
    userEventId: yup.number().nullable().min(1).required().defined(),
    paymentTypeId: yup.number().min(1).required().defined(),
    // Used for custom-price methods (cash / card / bank / etc.) — ignored by the BE
    // for Plan (per-visit price computed from subscription) and Multisport/CoolFit
    // (BE applies the studio's tax percent to the event price).
    price: yup.number().nullable().min(0).defined(),
    currencyId: yup.number().nullable().defined(),
    // Required when paymentTypeId === PaymentTypes.Plan. BE re-validates server-side.
    subscriptionPlanId: yup.number().nullable().defined(),
    hasFilledForm: yup.boolean().nullable(),
  })
  .required();

export type IAddPaymentTypeFormData = yup.InferType<
  typeof addPaymentTypeFormSchema
>;

export const addPaymentTypeFormDefaultValues: IAddPaymentTypeFormData = {
  userEventId: 0,
  paymentTypeId: 0,
  price: 0,
  currencyId: CurrencyType.EUR,
  subscriptionPlanId: null,
  hasFilledForm: null,
};
